import React, { useState, useEffect } from 'react';
import { Hero } from '../../components/Hero';
import { ApplySection } from '../../components/ApplySection';
import Card from '../../components/Card';
import Categories from '../../components/Categories';
import { categories } from '../../helpers';
import SearchInput from '../../components/SearchInput';
import { SWAPCARD_API_KEY, EVENT_ID, SPEAKERS_GROUP_ID } from '../../consts';
import CheckItem from '../../components/CheckItem';
import './speakers.css';
import Speakers from '../../components/Speakers';

function SpeakersPage() {
  const [speakers, setSpeakers] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const operationsDoc = `
    query eventPerson($eventId: ID!, $filters: [EventPersonFilter!], $search: String) {
      eventPerson(eventId: $eventId, filters: $filters, sort: {field: LAST_NAME}, search: $search) {
        nodes {
          id
          clientIds
          email
          firstName
          lastName
          jobTitle
          organization
          photoUrl
          socialNetworks {
            profile
            type
          }
        }
      }
    }
  `;

  useEffect(() => {
    async function fetchGraphQL(operationsDoc, operationName, variables) {
      try {
        const result = await fetch(
          "https://developer.swapcard.com/event-admin/graphql",
          {
            method: "POST",
            headers: {
              "Authorization": SWAPCARD_API_KEY,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              query: operationsDoc,
              variables: variables,
              operationName: operationName
            })
          }
        );
        setSpeakers((await result.json())?.data?.eventPerson?.nodes);
      } catch(e) {
        console.log('error: ', e);
      }
    }

    const variables = {
      "eventId": EVENT_ID,
      filters: {
        shouldBeInGroups: SPEAKERS_GROUP_ID,
      },
      ...searchValue && { search: searchValue }
    };

    fetchGraphQL(operationsDoc, 'eventPerson', variables);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  const [values, setValues] = useState(categories);
  const selectedCategories = values.filter(item => item.checked);
  const filtered = speakers && speakers.filter(item => !item.sectors || (item.sectors && item.sectors.findIndex(catItem => selectedCategories.findIndex(indexItem => indexItem.label.toLowerCase() === catItem.toLowerCase()) > -1) > -1));

  const onItemClose = (index) => {
    values[index].checked = !values[index].checked;
    setValues([...values]);
  }

  const onSearch = (value) => {
    setSearchValue(value);
  }

  return (
    <div className="speakers">
      <div className="speakers-hero-wrapper">
        <Hero
          title="Speakers"
          description="Explore the Brilliant Minds at Ai4 2023, actively driving artificial intelligence and machine learning innovation in leading organizations."
          buttonLabel="APPLY TO SPEAK AT THE EVENT"
        />
      </div>
      <div className="meet-speakers">
        <div className="meet-speakers-text">
          <h2>At the front of AI Technology</h2>
        </div>
        <Speakers />
      </div>
      <div className="row flex-start-row">
        <div className="speakers-left">
          <SearchInput placeholder="Search" onChange={(value) => onSearch(value)} />
          <Categories values={values} onChange={(value) => setValues(value)} />
        </div>
        <div className="speakers-right">
          <div className="speakers-right-content">
            <div className="row flex-wrap gap-4">
              <CheckItem onClick={() => {}} label="Clear All" isClear></CheckItem>
              {
                values.map((category, index) => (
                  category.checked && <CheckItem onClick={() => onItemClose(index)} label={category.label} key={index} />
                ))
              }
            </div>
            <div className="row flex-start-row flex-wrap">
              {
                filtered && filtered.map(person => (
                  <div className="result-card-wrapper">
                    <Card person={person} />
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
      <ApplySection
        title="Become a Speaker"
        description="Speak at Ai4 and become part of AI industry history. People attend Ai4 to learn how AI will impact their industry, their company, their career, and the world at large."
        buttonLabel="Register now"
        inputPlaceholder="Your Email"
      />
    </div>
  );
}

export default SpeakersPage;
